import styled from 'styled-components';

import { BigSubtitle, SmallTitle, style } from '@genially/design-system';

export const TopContent = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(1.5),
}));

export const StyledBigSubtitle = styled(BigSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const StyledSmallTitle = styled(SmallTitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const Separator = styled.div(({ theme: { color } }) => ({
  backgroundColor: color.background.tertiary.default(),
  height: 1,
  width: '100%',
}));

export const BottomContent = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(3),
}));

export const ContentWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.size.units(2),
  height: '100%',
  justifyContent: 'space-between',

  overflowY: 'auto',

  ...style.mixins.scrollbar(theme),
}));
